import { MediaTrayView } from "@softmax/product-ux/editor";
import { useMediaTray } from "./use-media-tray";

export function MediaTray() {
  const view = useMediaTray();
  return <MediaTrayView {...view} />;
}
